import { render, staticRenderFns } from "./mail-reply-manager.vue?vue&type=template&id=656e9c94&scoped=true&"
import script from "./mail-reply-manager.vue?vue&type=script&lang=js&"
export * from "./mail-reply-manager.vue?vue&type=script&lang=js&"
import style0 from "./mail-reply-manager.vue?vue&type=style&index=0&id=656e9c94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e9c94",
  null
  
)

export default component.exports